<template>
    <div class="col-md-12 col-lg-12 mobile_pr_15 split-items-by-address">

        <div class="white_box  shipping_fl_left">
            <h1 class="heading1">3. Split Items By Delivery Address</h1>
            
            <!-- Current Address Info (show only on product assignment screen) -->
             <div v-if="!showSummary" class="address_main">

                <div class="current-address-section" v-if="currentAddress">
                <div class="ship-to-header mb-2">
                    <span class="ship-to-text">SHIP TO:</span>
                    <!-- <span class="address-title">{{ currentAddress.address_title || `Address ${currentAddressIndex + 1}` }}</span> -->
                    <span v-if="currentAddress.is_default" class="badge-primary">Default Address</span>
                </div>
                <div class="address-details">
                    <span class="customer_name" v-if="currentAddress.company_name"><strong>{{ currentAddress.company_name }},</strong> </span>
                    <span v-if="currentAddress.fullname">{{ currentAddress.fullname }}, </span>
                    <span v-if="currentAddress.address_line1">{{ currentAddress.address_line1 }}, </span>
                    <span v-if="currentAddress.address_line2">{{ currentAddress.address_line2 }}, </span>
                    <span v-if="currentAddress.city">{{ currentAddress.city }}, </span>
                    <span v-if="currentAddress.state">{{ currentAddress.state }} </span>
                    <span v-if="currentAddress.zip">{{ currentAddress.zip }}</span>
                </div>
            </div>
            <div class="right_items_main">
 <div class="address-progress-bar" v-show="orderedSplitAddresses && orderedSplitAddresses.length > 0">
                    <div class="progress-info mb-2">
                        <span class="progress-text">
                            Address {{ currentOrderedPosition + 1 }} - <strong>{{ getCurrentAddressTitle() }}</strong>
                        </span>
                    </div>
                    <div class="progress-bar-container">
                        <span
                            v-for="(address, index) in orderedSplitAddresses"
                            :key="'addr-step-' + index"
                            :class="['progress-step', { 'progress-step-active': index === currentOrderedPosition }]"
                            role="button"
                            tabindex="0"
                            :title="'Address ' + (index + 1) + ' — click to edit assignment'"
                            @click="selectAddressByOrderedIndex(index)"
                            @keydown.enter.prevent="selectAddressByOrderedIndex(index)"
                            @keydown.space.prevent="selectAddressByOrderedIndex(index)"
                        ></span>
                    </div>
                    <!-- <div class="progress-stats mt-2">
                        <span class="progress-count">{{ currentAddressIndex + 1 }} of {{ splitAddresses.length }}</span>
                    </div> -->
                      
                </div>
                <div class="products-summary_block">
                <div class="total_product">
                    <p>Total {{ expandedItems.length }} Products</p>
                </div>
                <div class="selected_product">
                    <p>Selected {{ selectedItemsCount }} Products</p>
                </div>
            </div>
            </div>
               
             </div>
            

            <!-- Summary Screen (After All Addresses Completed) -->
            <div v-if="showSummary" class="summary-screen">
                <!-- Success Message (All Items Assigned) -->
                <div v-if="allItemsAssigned" class="alert alert-success mb-4 d-flex align-items-center" role="alert">
                    <img src="/maincss/images/icons/green_check.svg" alt="edit" class="mr-2" style="width: 20px; height: 20px;" /> All {{ totalProductsCount }} Products Are Now Assigned.
                </div>
                
                <!-- Warning Message (Items Remaining) -->
                <div v-else class="alert alert-danger  d-flex align-items-center justify-content-between" role="alert">
                    {{ remainingProductsCount }} Remaining Products Need To Be Assigned. Please Distribute Them To Any Address Of Your Choice.
                    <!-- <button
                        type="button"
                        class="btn btn-link text-white p-0 ml-3 font-weight-bold"
                        @click="addNewAddress"
                    >
                        + Add Address
                    </button> -->
                </div>

                <!-- Add Address Option (Only show if all items assigned) -->
                <div  class="d-flex justify-content-end mb-0">
                    <button
                        type="button"
                        class="btn btn-link text_primary_blue p-0 add_address"
                        @click="addNewAddress"
                    >
                        + Add Address
                    </button>
                </div>

                <!-- Addresses List with Product Counts -->
                <div class="addresses-summary-list">
                    <div 
                        v-for="(address, addrIndex) in orderedSplitAddresses" 
                        :key="address.id || address._originalIndex || addrIndex"
                        class="address-summary-item"
                    >
                        <div class="address-summary-row d-flex justify-content-between align-items-center">
                            <div class="address-summary-left">
                                <span class="address-summary-label">Address {{ addrIndex + 1 }}:</span>
                                <span class="address-summary-details">
                                    {{ getAddressDisplayName(address) }}{{ address.company_name ? ', ' + address.company_name : '' }}{{ address.fullname ? ', ' + address.fullname : '' }}{{ address.address_line1 ? ', ' + address.address_line1 : '' }}{{ address.city ? ', ' + address.city : '' }}{{ address.state ? ', ' + address.state : '' }}{{ address.zip ? ' ' + address.zip : '' }}
                                </span>
                            </div>
                            <div class="address-summary-right d-flex align-items-center">
                                <span v-if="address.is_default" class="badge-primary">Default Address</span>
                                <label v-else class="address-set-default checkbox_custom mb-0">
                                    <span class="set-default-text">Set as Default</span>
                                    <input
                                        type="radio"
                                        :name="'summary_default_address'"
                                        :value="address._originalIndex"
                                        :checked="address.is_default"
                                        @change="setDefaultAddress(address._originalIndex)"
                                        :disabled="getAssignedProductsCount(address, address._originalIndex) === 0"
                                    />
                                    <span class="checkmark radio-mark"></span>
                                </label>
                                <span class="address-products-count">{{ getAssignedProductsCount(address, address._originalIndex) }} Products Added</span>
                                <button
                                    type="button"
                                    class="btn-add-product"
                                    @click="viewProductsForAddress(address._originalIndex)"
                                >
                                {{ allItemsAssigned ? 'View Products' : 'Add Products' }} 
                                </button>
                                <button
                                    type="button"
                                    class="btn-edit-address"
                                    aria-label="Edit address"
                                    @click="editAddressAssignment(address._originalIndex)"
                                >
                                    <img src="/maincss/images/icons/new-edit.svg" alt="edit" class="mr-1" style="width: 14px; height: 14px;" />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Disclaimer -->
                <!-- <div class="disclaimer mt-4">
                    <p class="mb-0">
                        Disclaimer: Final Kitting Costs May Be More Or Less Than Shown, This Amount Should Be Considered An Estimate. Shipping Costs Can Vary Significantly Based On Location.
                    </p>
                </div> -->
            </div>

            <!-- Product Assignment Screen (Default) -->
            <template v-else>
                <!-- Address Progress Bar -->
               

                <!-- Products Summary -->
          

            <!-- Products Table -->
            <div class="products-table-section" v-if="expandedItems.length > 0">
                <table class="table table-bordered">
                    <thead>
                        <tr>
                            <th>Product</th>
                            <th>Description</th>
                            <th>Color</th>
                            <th class="text-center">Size</th>
                            <th>Name</th>
                            <th class="text-center">Number</th>
                            <th class="text-center">Qty</th>
                            <th class="text-center select-col-header">
                                Select
                                <input
                                    type="checkbox"
                                    class="select-all-cb"
                                    :checked="isAllSelected"
                                    :indeterminate.prop="isSelectAllIndeterminate"
                                    :title="'Select'"
                                    aria-label="Select all"
                                    @change="toggleSelectAll($event)"
                                />
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in expandedItems" :key="item.uniqueKey">
                            <td>{{ item.product_number || 'N/A' }}</td>
                            <td>{{ item.product_name || 'N/A' }}</td>
                            <td>{{ item.color_name || 'N/A' }}</td>
                            <td class="text-center">{{ item.size_name || 'N/A' }}</td>
                            <td>{{ item.decorator_name || '-' }}</td>
                            <td class="text-center">{{ item.decorator_number || '-' }}</td>
                            <td class="text-center">1</td>
                            <td class="text-center">
                                <input 
                                    type="checkbox" 
                                    :checked="isItemSelected(item)"
                                    @change="toggleItemSelection(item, $event)"
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- No Products Message -->
            <div v-else class="alert alert-info">
                <p>All products have been assigned to addresses.</p>
            </div>

                <!-- Disclaimer -->
                
            </template>

            <!-- Action Buttons removed - footer NEXT button handles navigation -->
            
            <!-- Summary screen has no buttons - footer handles navigation -->
        </div>
        <div class="disclaimer">
            <p class="text-muted small">
                Disclaimer: Final Kitting Costs May Be More Or Less Than Shown, This Amount Should Be Considered An Estimate. Shipping Costs Can Vary Significantly Based On Location.
            </p>
        </div>

    </div>
</template>

<script>
export default {
    name: "SplitItemsByAddress",
    data() {
        return {
            currentAddressIndex: 0,
            currentOrderedPosition: 0,
            selectedItemsForCurrentAddress: [],
            expandedItems: [],
            allExpandedItems: [],
            showSummary: false,
            toastCooldownTracker: {}
        };
    },
    computed: {
        isSplitShipment() {
            return this.$store.state.splitShipment && this.$store.state.splitShipment.isSplitShipment;
        },
        splitAddresses() {
            const splitShipmentModule = this.$store.state.splitShipment;
            const addresses = splitShipmentModule && splitShipmentModule.splitAddresses;
            
            // Ensure we return an array
            const addressesArray = Array.isArray(addresses) ? addresses : [];
            
            return addressesArray;
        },
        orderedSplitAddresses() {
            const addresses = Array.isArray(this.splitAddresses) ? this.splitAddresses : [];
            return addresses
                .map((address, index) => ({ ...address, _originalIndex: index }));
        },
        currentOrderedIndex() {
            return this.orderedSplitAddresses.findIndex(
                (a) => a._originalIndex === this.currentAddressIndex
            );
        },
        productAssignments() {
            return this.$store.state.splitShipment && this.$store.state.splitShipment.productAssignments || {};
        },
        currentAddress() {
            if (this.splitAddresses && this.splitAddresses.length > 0 && this.currentAddressIndex < this.splitAddresses.length) {
                return this.splitAddresses[this.currentAddressIndex];
            }
            return null;
        },
        selectedItemsCount() {
            return this.selectedItemsForCurrentAddress.length;
        },
        isAllSelected() {
            if (!this.expandedItems || this.expandedItems.length === 0) return false;
            return this.expandedItems.every(item =>
                this.selectedItemsForCurrentAddress.some(s => s.uniqueKey === item.uniqueKey)
            );
        },
        isSelectAllIndeterminate() {
            const n = this.selectedItemsCount;
            return n > 0 && n < (this.expandedItems || []).length;
        },
        addressProgressPercentage() {
            const total = this.orderedSplitAddresses.length;
            if (total === 0) return 0;
            return ((this.currentOrderedPosition + 1) / total) * 100;
        },
        totalProductsCount() {
            // Count total assigned products across all addresses
            const assignments = this.productAssignments || {};
            return Object.keys(assignments).filter(key => assignments[key] && assignments[key].selected).length;
        },
        remainingProductsCount() {
            // Count remaining unassigned products
            const totalItems = this.allExpandedItems.length;
            const assignedItems = this.totalProductsCount;
            return totalItems - assignedItems;
        },
        allItemsAssigned() {
            // Check if all items are assigned
            return this.remainingProductsCount === 0 && this.allExpandedItems.length > 0;
        }
    },
    mounted() {
        // Start from default address when available (may be last address if all items sit on one)
        this.currentAddressIndex = this.getPreferredStartAddressIndex(this.splitAddresses);
        this.syncOrderedPositionFromIndex();
        
        // Wait for Vuex state to be available
        this.$nextTick(() => {
            this.checkAndLoadAddresses();
        });
        
        // Wait for CartSummary to be ready
        this.$nextTick(() => {
            setTimeout(() => {
                this.loadCartItems();
            }, 500);
        });
    },
    watch: {
        currentAddressIndex() {
            this.loadProductsForAddress();
        },
        splitAddresses: {
            handler(newVal, oldVal) {
                if (newVal && newVal.length > 0) {
                    // Addresses are now available
                    if (this.currentAddressIndex >= newVal.length) {
                        this.currentAddressIndex = this.getPreferredStartAddressIndex(newVal);
                    }
                    this.syncOrderedPositionFromIndex();
                    this.loadProductsForAddress();
                }
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        loadCartItems() {
            // Get cart items from CartSummary component
            const cartSummaryRef = this.$parent.$refs.cartSummaryRef;
            if (!cartSummaryRef) {
                console.warn("[SplitItemsByAddress] CartSummary ref not available");
                // Retry after a delay
                setTimeout(() => {
                    this.loadCartItems();
                }, 500);
                return;
            }

            const cartItems = cartSummaryRef.cart_items;
            if (!cartItems || cartItems.length === 0) {
                console.warn("[SplitItemsByAddress] No cart items available, cartItems:", cartItems);
                this.expandedItems = [];
                this.allExpandedItems = [];
                return;
            }

            const expanded = [];
            // Track processed childItems to avoid duplicates: Set of "cartItemId_childItemId_colorId_sizeId"
            const processedItems = new Set();

            cartItems.forEach((cartItem, cartItemIndex) => {

                // FIRST: Process parent's CartChildItems (these might contain colors not in subItems)
                // This is important because parent CartChildItems might have Red color while subItems have Grey
                if (cartItem.CartChildItems && cartItem.CartChildItems.length > 0) {
                    cartItem.CartChildItems.forEach((childItem) => {
                        // Get color_id to create unique key
                        const mainProduct = childItem.main_new_sub_product;
                        const colorObj = mainProduct && mainProduct.Color;
                        const colorId = childItem.color_id || (colorObj && colorObj.id) || 'no_color';
                        const sizeId = childItem.gender_size_id || (mainProduct && mainProduct.Size && mainProduct.Size.id) || 'no_size';
                        
                        // Create unique key for this childItem
                        const uniqueKey = `${cartItem.id}_${childItem.id}_${colorId}_${sizeId}`;
                        
                        // Only process if not already processed
                        if (!processedItems.has(uniqueKey)) {
                            processedItems.add(uniqueKey);
                            this.expandChildItem(childItem, cartItem, expanded, cartItem);
                        }
                    });
                }

                // THEN: Process subItems if they exist (for multi-color items)
                // These might have additional colors or different quantities
                if (cartItem.subItems && cartItem.subItems.length > 0) {
                    cartItem.subItems.forEach((subItem, subItemIndex) => {
                        if (subItem.CartChildItems && subItem.CartChildItems.length > 0) {
                            subItem.CartChildItems.forEach((childItem) => {
                                // Get color_id to create unique key
                                const mainProduct = childItem.main_new_sub_product;
                                const colorObj = mainProduct && mainProduct.Color;
                                const colorId = childItem.color_id || (colorObj && colorObj.id) || 'no_color';
                                const sizeId = childItem.gender_size_id || (mainProduct && mainProduct.Size && mainProduct.Size.id) || 'no_size';
                                
                                // Create unique key for this childItem
                                const uniqueKey = `${cartItem.id}_${childItem.id}_${colorId}_${sizeId}`;
                                
                                // Only process if not already processed from parent CartChildItems
                                if (!processedItems.has(uniqueKey)) {
                                    processedItems.add(uniqueKey);
                                this.expandChildItem(childItem, subItem, expanded, cartItem);
                                }
                            });
                        }
                    });
                }
            });

            this.allExpandedItems = expanded;
            this.loadProductsForAddress();
        },
        showToastWithCooldown(type, key, message, options = {}, cooldownMs = 3500) {
            const now = Date.now();
            const lastShownAt = this.toastCooldownTracker[key] || 0;

            if (now - lastShownAt < cooldownMs) {
                return;
            }

            this.toastCooldownTracker[key] = now;

            if (this.$toast[type]) {
                this.$toast[type](message, options);
            } else {
                console.warn(`Invalid toast type: ${type}`);
            }
        },
        expandChildItem(childItem, parentItem, expandedArray, rootCartItem) {
            const quantity = parseInt(childItem.quantity || 0);
            
            // Skip items with 0 quantity
            if (quantity <= 0) {
                return;
            }
            
            const mainProduct = childItem.main_new_sub_product;
            
            // Get product info from root cart item
            const productNumber = (rootCartItem.main_new_product && rootCartItem.main_new_product.product_number) || 
                                  rootCartItem.product_number || 
                                  parentItem.product_number || 
                                  'N/A';
            const productName = (rootCartItem.main_new_product && rootCartItem.main_new_product.name) || 
                                rootCartItem.name || 
                                parentItem.name || 
                                'N/A';
            
            // Get color info
            const colorObj = mainProduct && mainProduct.Color;
            const colorName = (colorObj && colorObj.name) || (colorObj && colorObj.color_name) || 'N/A';
            
            // Get size info
            const sizeObj = mainProduct && mainProduct.Size;
            let sizeName = 'N/A';
            if (sizeObj) {
                if (sizeObj.size_name) {
                    sizeName = sizeObj.size_name;
                } else if (sizeObj.size) {
                    const sizeParts = sizeObj.size.trim().split(/\s+/);
                    sizeName = sizeParts[sizeParts.length - 1];
                } else if (sizeObj.name) {
                    const nameParts = sizeObj.name.trim().split(/\s+/);
                    sizeName = nameParts[nameParts.length - 1];
                }
            }

            // Get name and number from name_and_number_json (check both rootCartItem and parentItem)
            // Structure: { front: [{name, number, size, ...}], back: [...], left: [...], right: [...], selected_name_number: {...} }
            // Extract name/number per item based on index and selected location
            const nameNumberJson = rootCartItem.name_and_number_json || parentItem.name_and_number_json;
            let nameNumberData = null;
            let nameLocation = 'front';
            let numberLocation = 'front';
            
            if (nameNumberJson) {
                try {
                    if (typeof nameNumberJson === 'string') {
                        nameNumberData = JSON.parse(nameNumberJson);
                    } else if (typeof nameNumberJson === 'object') {
                        nameNumberData = nameNumberJson;
                    }
                    
                    // Determine which location to use based on selected_name_number
                    if (nameNumberData && nameNumberData.selected_name_number) {
                        const selected = nameNumberData.selected_name_number;
                        const locs = ['front', 'back', 'left', 'right'];
                        // Pick independently: first location with name enabled / number enabled.
                        for (let li = 0; li < locs.length; li++) {
                            const loc = locs[li];
                            if (selected[loc] && selected[loc].name) {
                                nameLocation = loc;
                                break;
                            }
                        }
                        for (let li = 0; li < locs.length; li++) {
                            const loc = locs[li];
                            if (selected[loc] && selected[loc].number) {
                                numberLocation = loc;
                                break;
                            }
                        }
                    }
                } catch (e) {
                    console.warn("[SplitItemsByAddress] Error parsing name_and_number_json:", e);
                }
            }

            // Build deterministic mapping: shared table rows assigned by size (not by i index).
            const normalizeSize = (v) =>
                v == null ? "" : String(v).trim().toUpperCase();
            const buildRowsBySizeForLocation = (loc) => {
                const rows =
                    nameNumberData &&
                    nameNumberData[loc] &&
                    Array.isArray(nameNumberData[loc])
                        ? nameNumberData[loc]
                        : [];
                const bySize = {};
                rows.forEach((row) => {
                    const k = normalizeSize(row && row.size);
                    const key = k !== "" ? k : "*";
                    if (!bySize[key]) bySize[key] = [];
                    bySize[key].push(row);
                });
                return bySize;
            };
            const rowsBySizeByLoc = {
                front: buildRowsBySizeForLocation('front'),
                back: buildRowsBySizeForLocation('back'),
                left: buildRowsBySizeForLocation('left'),
                right: buildRowsBySizeForLocation('right')
            };
            const cursorByLocSize = { front: {}, back: {}, left: {}, right: {} };
            const nextRowForLocSize = (loc, sizeKey) => {
                const map = rowsBySizeByLoc[loc] || {};
                const bucket = map[sizeKey] || map["*"] || [];
                const cur = cursorByLocSize[loc][sizeKey] || 0;
                const row = bucket[cur];
                if (row) cursorByLocSize[loc][sizeKey] = cur + 1;
                return row || null;
            };

            // Get color_id for unique key generation
            const colorId = childItem.color_id || (colorObj && colorObj.id) || 'no_color';
            const sizeId = childItem.gender_size_id || (sizeObj && sizeObj.id) || 'no_size';

            // Expand based on quantity - create individual rows (12 items S = 12 rows with qty 1)
            for (let i = 0; i < quantity; i++) {
                // Create stable unique key including color_id to ensure uniqueness across color variants
                // Format: cart_{cartItemId}_color_{colorId}_child_{childItemId}_size_{sizeId}_qty_{i}
                const uniqueKey = `cart_${rootCartItem.id}_color_${colorId}_child_${childItem.id}_size_${sizeId}_qty_${i}`;
                
                // Extract name and number for this specific item (index i)
                let decoratorName = '-';
                let decoratorNumber = '-';
                let perRowNameAndNumberJson = null;

                const sizeKey = normalizeSize(sizeName);
                const nameItem =
                    nameLocation === numberLocation
                        ? nextRowForLocSize(nameLocation, sizeKey)
                        : nextRowForLocSize(nameLocation, sizeKey);
                const numberItem =
                    nameLocation === numberLocation
                        ? nameItem
                        : nextRowForLocSize(numberLocation, sizeKey);

                if (nameItem) {
                    decoratorName =
                        nameItem.name || nameItem.decorator_name || '-';
                }
                if (numberItem) {
                    decoratorNumber =
                        numberItem.number ||
                        numberItem.decorator_number ||
                        '-';
                }

                if (nameItem || numberItem) {
                    const normalizeStr = (v) => (v == null ? '' : String(v));
                    const nameVal = nameItem
                        ? normalizeStr(
                              nameItem.name || nameItem.decorator_name || ''
                          )
                        : '';
                    const numberVal = numberItem
                        ? normalizeStr(
                              numberItem.number ||
                                  numberItem.decorator_number ||
                                  ''
                          )
                        : '';
                    const hasName = nameVal.trim().length > 0;
                    const hasNumber = numberVal.trim().length > 0;

                    // Build per-row name_and_number_json so split payload matches the specific unit
                    const baseSelected = {
                        front: { name: false, number: false },
                        back: { name: false, number: false },
                        left: { name: false, number: false },
                        right: { name: false, number: false }
                    };
                    if (hasName) baseSelected[nameLocation].name = true;
                    if (hasNumber) baseSelected[numberLocation].number = true;

                    const perRowObj = {
                        front: [],
                        back: [],
                        left: [],
                        right: [],
                        selected_name_number: baseSelected
                    };

                    // Preserve extra metadata on original row item(s).
                    // IMPORTANT: when nameLocation === numberLocation, do NOT write two separate
                    // entries — the second write would overwrite the first and erase the name.
                    // Instead write a single entry that carries BOTH name and number.
                    if (hasName && hasNumber && nameLocation === numberLocation) {
                        perRowObj[nameLocation] = [
                            {
                                ...nameItem,
                                name: nameVal,
                                number: numberVal
                            }
                        ];
                    } else {
                        if (hasName) {
                            perRowObj[nameLocation] = [
                                {
                                    ...nameItem,
                                    name: nameVal,
                                    number: ''
                                }
                            ];
                        }
                        if (hasNumber) {
                            perRowObj[numberLocation] = [
                                {
                                    ...numberItem,
                                    name: '',
                                    number: numberVal
                                }
                            ];
                        }
                    }

                    perRowNameAndNumberJson = JSON.stringify(perRowObj);
                }
                
                // IMPORTANT: do NOT fall back to the full cart-level name_and_number_json.
                // For split-by-address we only want per-unit personalization here; blank units should send null
                // and Checkout will merge only filled entries (Option 2: clean JSON).
                const nameAndNumberJsonVal = perRowNameAndNumberJson;
                const itemData = {
                    uniqueKey: uniqueKey,
                    // IMPORTANT: use the specific cart row id (parentItem)
                    // so that different colors (subItems) get different cart_item_id values.
                    // For parent CartChildItems, parentItem === rootCartItem so this still works.
                    cartItemId: parentItem.id || parentItem.item_id || rootCartItem.id,
                    childItemId: childItem.id,
                    product_number: productNumber,
                    product_name: productName,
                    color_name: colorName,
                    size_name: sizeName,
                    quantity: 1, // Always 1 for expanded items
                    unit_price: childItem.unit_price || 0,
                    decorator_name: decoratorName,
                    decorator_number: decoratorNumber,
                    originalQuantity: quantity,
                    originalIndex: i,
                    color_id: colorId,
                    size_id: sizeId,
                    parentItemId: parentItem.id || parentItem.item_id || null,
                    name_and_number_json: nameAndNumberJsonVal || null
                };
                expandedArray.push(itemData);
            }
        },
        loadProductsForAddress() {
            if (this.allExpandedItems.length === 0) {
                // If items not loaded yet, try loading again
                this.loadCartItems();
                return;
            }
            
            // Filter out already assigned items (items assigned to OTHER addresses)
            const assignedItemKeys = this.getAssignedItemKeys();
            this.expandedItems = this.allExpandedItems.filter(item => {
                // Show item if it's not assigned to any address, OR if it's assigned to current address (so user can unselect)
                const assignment = this.productAssignments[item.uniqueKey];
                if (assignment && assignment.selected) {
                    // If assigned to current address, show it (so user can unselect)
                    if (assignment.addressIndex === this.currentAddressIndex) {
                        return true;
                    }
                    // If assigned to other address, hide it
                    return false;
                }
                // Not assigned, show it
                return true;
            });
            
            // Load selected items for current address
            this.loadAssignedItems();
        },
        getAssignedItemKeys() {
            // Get all assigned item keys from Vuex store
            const assignments = this.productAssignments;
            const assignedKeys = [];
            
            Object.keys(assignments).forEach(key => {
                if (assignments[key] && assignments[key].selected) {
                    assignedKeys.push(key);
                }
            });
            
            return assignedKeys;
        },
        loadAssignedItems() {
            // Load items already assigned to current address
            const assignments = this.productAssignments;
            this.selectedItemsForCurrentAddress = [];
            
            Object.keys(assignments).forEach(key => {
                const assignment = assignments[key];
                if (assignment && assignment.selected && assignment.addressIndex === this.currentAddressIndex) {
                    const item = this.allExpandedItems.find(i => i.uniqueKey === key);
                    if (item) {
                        this.selectedItemsForCurrentAddress.push(item);
                    }
                }
            });
        },
        isItemSelected(item) {
            return this.selectedItemsForCurrentAddress.some(selected => selected.uniqueKey === item.uniqueKey);
        },
        toggleItemSelection(item, event) {
            if (event.target.checked) {
                // Add to selected items
                if (!this.selectedItemsForCurrentAddress.find(i => i.uniqueKey === item.uniqueKey)) {
                    this.selectedItemsForCurrentAddress.push(item);
                }
            } else {
                // Remove from selected items
                this.selectedItemsForCurrentAddress = this.selectedItemsForCurrentAddress.filter(
                    i => i.uniqueKey !== item.uniqueKey
                );
            }
        },
        toggleSelectAll(event) {
            if (event.target.checked) {
                this.selectedItemsForCurrentAddress = [...(this.expandedItems || [])];
            } else {
                this.selectedItemsForCurrentAddress = [];
            }
        },
        saveAndNextAddress() {
            
            // Get addresses directly from Vuex store (not computed property)
            const storeAddresses = this.$store.state.splitShipment && this.$store.state.splitShipment.splitAddresses;
            
            // if (this.selectedItemsCount === 0) {
            //     this.$toast.warning("Please select at least one product for this address", {
            //         position: "top-right"
            //     });
            //     return;
            // }

            // Check if addresses are available - use store directly
            const addresses = storeAddresses || this.splitAddresses || [];
            // User can skip address (commented: at least one product per address not required)
            // if (this.selectedItemsCount === 0) {
            //     this.$toast.warning("Please select at least one product for this address", { position: "top-right" });
            //     return;
            // }
            if (!addresses || addresses.length === 0) {
                console.error("[SplitItemsByAddress] No addresses found in Vuex store");
                console.error("[SplitItemsByAddress] Full Vuex state:", this.$store.state.splitShipment);
                this.$toast.error("No addresses found. Please go back and add addresses first.", {
                    position: "top-right"
                });
                return;
            }

            // Get current address directly from addresses array
            const currentAddr = addresses[this.currentAddressIndex];
            if (!currentAddr) {
                console.error("[SplitItemsByAddress] Current address not found at index:", this.currentAddressIndex);
                console.error("[SplitItemsByAddress] Available addresses:", addresses);
                this.$toast.error("Current address not found. Please refresh the page.", {
                    position: "top-right"
                });
                return;
            }

            const assignments = this.persistCurrentAddressAssignments(currentAddr);
            
            // Show success message
            const addressName = currentAddr.company_name || currentAddr.address_title || `Address ${this.currentAddressIndex + 1}`;
            // this.$toast.success(`Items saved for ${addressName}`, {
            //     position: "top-right"
            // });
            
            // After save, decide where to go next (use ordered sequence with explicit position)
            const totalAddresses = this.orderedSplitAddresses.length;
            const minAddressesForNameNumber = 2;
            const isLastAddress = this.currentOrderedPosition >= totalAddresses - 1;

            // Recalculate assignment stats using local assignments we just saved
            const totalItems = this.allExpandedItems.length;
            const assignedItems = Object.keys(assignments).filter(
                key => assignments[key] && assignments[key].selected
            ).length;
            const allAssigned = totalItems > 0 && assignedItems === totalItems;

            const addressIndices = new Set();
            Object.keys(assignments).forEach(key => {
                const a = assignments[key];
                if (a && a.selected && a.addressIndex !== undefined) {
                    addressIndices.add(a.addressIndex);
                }
            });
            const addressesWithProductsCount = addressIndices.size;

            // If all products are assigned
            if (allAssigned) {
                // Enforce: at least 2 addresses must have products
                if (addressesWithProductsCount < minAddressesForNameNumber) {
                    this.showToastWithCooldown("warning", "split-items-by-address-min-addresses", "Please assign products to at least 2 addresses before proceeding.", {
                        position: "top-right",
                        duration: 4000
                    });
                    this.jumpToAddressForMinTwoAddressesError();
                    return;
                }
                // All products assigned to at least 2 addresses: go straight to summary
                this.showSummaryAfterSave();
                return;
            }

            // Not all products assigned yet: move to next address in ordered sequence
            if (totalAddresses > 0 && !isLastAddress) {
                const nextPos = this.currentOrderedPosition + 1;
                const nextOrdered = this.orderedSplitAddresses[nextPos];
                this.currentAddressIndex = nextOrdered._originalIndex;
                this.currentOrderedPosition = nextPos;
                this.$nextTick(() => {
                    this.loadProductsForAddress();
                });
            } else {
                const addressesWithProductsCountFinal = this.countAddressesWithAssignments();
                if (addressesWithProductsCountFinal < minAddressesForNameNumber) {
                    this.showToastWithCooldown("warning", "split-items-by-address-min-addresses", "Please assign products to at least 2 addresses before proceeding.", {
                        position: "top-right",
                        duration: 4000
                    });
                    this.jumpToAddressForMinTwoAddressesError();
                    return;
                }
                this.showSummaryAfterSave();
            }
        },
        countAddressesWithAssignments() {
            const assignments = this.productAssignments || {};
            const addressIndices = new Set();
            Object.keys(assignments).forEach(key => {
                const assignment = assignments[key];
                if (assignment && assignment.selected && assignment.addressIndex !== undefined) {
                    addressIndices.add(assignment.addressIndex);
                }
            });
            return addressIndices.size;
        },
        showSummaryAfterSave() {
            this.$nextTick(() => {
                const remaining = this.remainingProductsCount;
                const allAssigned = this.allItemsAssigned;
                this.showSummary = true;
                if (allAssigned) {
                    this.$toast.success("All items have been assigned to addresses", {
                        position: "top-right"
                    });
                } else {
                    this.showToastWithCooldown("warning", "split-items-by-address-items-remaining", `${remaining} items still need to be assigned`, {
                        position: "top-right"
                    });
                }
            });
        },
        goBackToAddresses() {
            this.$emit('go-back-to-addresses');
        },
        checkAndLoadAddresses() {
            // Check if addresses exist in Vuex
            const splitShipmentModule = this.$store.state.splitShipment;
            const storeAddresses = splitShipmentModule && splitShipmentModule.splitAddresses;
            
            // Check if it's an array and has items
            const addressesArray = Array.isArray(storeAddresses) ? storeAddresses : [];
            const addressesLength = addressesArray.length;
            
            if (addressesLength === 0) {
                // Try again after a short delay (addresses might be loading)
                setTimeout(() => {
                    const retryModule = this.$store.state.splitShipment;
                    const retryAddresses = retryModule && retryModule.splitAddresses;
                    const retryArray = Array.isArray(retryAddresses) ? retryAddresses : [];
                    
                    if (retryArray.length > 0) {
                        this.currentAddressIndex = this.getPreferredStartAddressIndex(retryArray);
                        this.syncOrderedPositionFromIndex();
                        // Force reactivity update
                        this.$forceUpdate();
                    } else {
                        // If still no addresses after retry, wait a bit more
                        setTimeout(() => {
                            const finalModule = this.$store.state.splitShipment;
                            const finalAddresses = finalModule && finalModule.splitAddresses;
                            const finalArray = Array.isArray(finalAddresses) ? finalAddresses : [];
                            if (finalArray.length > 0) {
                                this.currentAddressIndex = this.getPreferredStartAddressIndex(finalArray);
                                this.syncOrderedPositionFromIndex();
                                this.$forceUpdate();
                            } else {
                                console.error("[SplitItemsByAddress] No addresses found after all retries. Please go back and add addresses.");
                            }
                        }, 500);
                    }
                }, 300);
            } else {
                this.currentAddressIndex = this.getPreferredStartAddressIndex(addressesArray);
                this.syncOrderedPositionFromIndex();
            }
        },
        getPreferredStartAddressIndex(addresses) {
            if (!Array.isArray(addresses) || addresses.length === 0) {
                return 0;
            }
            // If everything sits on one address (invalid for split), land on that address so the user can move items.
            const withProducts = this.countAddressesWithAssignments();
            if (withProducts === 1) {
                const onlyIdx = this.getLastAssignedAddressIndex();
                if (onlyIdx >= 0) {
                    return onlyIdx;
                }
            }
            return 0;
        },
        selectAddressByOrderedIndex(orderIndex) {
            if (this.showSummary) {
                return;
            }
            const ordered = this.orderedSplitAddresses || [];
            if (orderIndex < 0 || orderIndex >= ordered.length) {
                return;
            }
            if (orderIndex === this.currentOrderedPosition) {
                return;
            }
            const addresses = Array.isArray(this.splitAddresses) ? this.splitAddresses : [];
            const currentAddr = addresses[this.currentAddressIndex];
            if (currentAddr) {
                this.persistCurrentAddressAssignments(currentAddr);
            }
            const target = ordered[orderIndex];
            this.currentAddressIndex = target._originalIndex;
            this.currentOrderedPosition = orderIndex;
            this.$nextTick(() => {
                this.loadProductsForAddress();
                this.loadAssignedItems();
            });
        },
        jumpToAddressForMinTwoAddressesError() {
            this.showSummary = false;
            const idx = this.getLastAssignedAddressIndex();
            if (idx < 0) {
                return;
            }
            this.currentAddressIndex = idx;
            this.syncOrderedPositionFromIndex();
            this.$nextTick(() => {
                this.loadProductsForAddress();
                this.loadAssignedItems();
            });
        },
        syncOrderedPositionFromIndex() {
            const pos = this.orderedSplitAddresses.findIndex(
                (a) => a._originalIndex === this.currentAddressIndex
            );
            this.currentOrderedPosition = pos >= 0 ? pos : 0;
        },
        getCurrentAddressTitle() {
            // Priority: company_name > address_title > Address X
            if (this.currentAddress) {
                if (this.currentAddress.company_name) {
                    return this.currentAddress.company_name;
                }
                if (this.currentAddress.address_title) {
                    return this.currentAddress.address_title;
                }
            }
            if (this.splitAddresses && this.splitAddresses.length > 0 && this.splitAddresses[this.currentAddressIndex]) {
                const addr = this.splitAddresses[this.currentAddressIndex];
                if (addr.company_name) {
                    return addr.company_name;
                }
                if (addr.address_title) {
                    return addr.address_title;
                }
            }
            return `Address ${this.currentAddressIndex + 1}`;
        },
        getAddressDisplayName(address) {
            if (address.company_name) return address.company_name;
            if (address.address_title) return address.address_title;
            return `Address`;
        },
        getAssignedProductsCount(address, addressIndex) {
            const assignments = this.productAssignments || {};
            let count = 0;
            Object.keys(assignments).forEach(key => {
                const assignment = assignments[key];
                if (assignment && assignment.selected && assignment.addressIndex === addressIndex) {
                    count++;
                }
            });
            return count;
        },
        viewProductsForAddress(addressIndex) {
            // Go back to assignment screen for this address
            this.showSummary = false;
            this.currentAddressIndex = addressIndex;
            this.currentOrderedPosition = this.orderedSplitAddresses.findIndex(a => a._originalIndex === addressIndex);
            this.$nextTick(() => {
                this.loadProductsForAddress();
                this.loadAssignedItems();
            });
        },
        setDefaultAddress(addrIndex) {
            const addresses = [...(this.splitAddresses || [])];
            addresses.forEach((addr, i) => {
                addr.is_default = (i === addrIndex);
            });
            this.$store.commit("splitShipment/setSplitAddresses", addresses);
        },
        editAddressAssignment(addressIndex) {
            // Go back to assignment screen for this address
            this.showSummary = false;
            this.currentAddressIndex = addressIndex;
            this.currentOrderedPosition = this.orderedSplitAddresses.findIndex(a => a._originalIndex === addressIndex);
            this.$nextTick(() => {
                this.loadProductsForAddress();
                // Load already assigned items for this address
                this.loadAssignedItems();
            });
        },
        addNewAddress() {
            // Go back to addresses step to add new address
            this.$emit('go-back-to-addresses');
        },
        goBackToEdit() {
            // Go back to last assigned address (fallback: last address)
            if (this.splitAddresses && this.splitAddresses.length > 0) {
                this.showSummary = false;
                this.currentAddressIndex = this.getLastAssignedAddressIndex();
                this.currentOrderedPosition = this.orderedSplitAddresses.findIndex(
                    (a) => a._originalIndex === this.currentAddressIndex
                );
                this.$nextTick(() => {
                    this.loadProductsForAddress();
                    this.loadAssignedItems();
                });
            }
        },
        getLastAssignedAddressIndex() {
            const addresses = Array.isArray(this.splitAddresses) ? this.splitAddresses : [];
            if (addresses.length === 0) return 0;

            const assignments = this.productAssignments || {};
            let lastAssignedIndex = -1;
            Object.keys(assignments).forEach((key) => {
                const assignment = assignments[key];
                if (!assignment || !assignment.selected) return;
                const idx = Number(assignment.addressIndex);
                if (Number.isInteger(idx) && idx >= 0 && idx < addresses.length) {
                    lastAssignedIndex = Math.max(lastAssignedIndex, idx);
                }
            });

            return lastAssignedIndex >= 0 ? lastAssignedIndex : addresses.length - 1;
        },
        persistCurrentAddressAssignments(currentAddr) {
            const assignments = { ...this.productAssignments };

            // Update assignments for current address
            this.selectedItemsForCurrentAddress.forEach(item => {
                assignments[item.uniqueKey] = {
                    addressIndex: this.currentAddressIndex,
                    addressId: currentAddr.id || currentAddr.address_id || null,
                    selected: true,
                    item: item
                };
            });

            // Remove items that were unselected from current address
            Object.keys(assignments).forEach(key => {
                const assignment = assignments[key];
                if (assignment && assignment.addressIndex === this.currentAddressIndex) {
                    if (!this.selectedItemsForCurrentAddress.find(i => i.uniqueKey === key)) {
                        delete assignments[key];
                    }
                }
            });

            this.$store.commit('splitShipment/setProductAssignments', assignments);
            return assignments;
        },
        // Back within split items; false = go to addresses step
        goToPreviousAddress() {
            if (this.showSummary) {
                // From summary: go to last address that has products assigned
                this.showSummary = false;
                if (this.splitAddresses && this.splitAddresses.length > 0) {
                    this.currentAddressIndex = this.getLastAssignedAddressIndex();
                    this.currentOrderedPosition = this.orderedSplitAddresses.findIndex(
                        (a) => a._originalIndex === this.currentAddressIndex
                    );
                    this.$nextTick(() => {
                        this.loadProductsForAddress();
                        this.loadAssignedItems();
                    });
                }
                return true;
            }
            if (this.currentOrderedPosition > 0) {
                // Persist edits on current address before moving to previous one
                const addresses = Array.isArray(this.splitAddresses) ? this.splitAddresses : [];
                const currentAddr = addresses[this.currentAddressIndex];
                if (currentAddr) {
                    this.persistCurrentAddressAssignments(currentAddr);
                }

                // Previous address in ordered sequence (use explicit position)
                const prevPos = this.currentOrderedPosition - 1;
                const prevOrdered = this.orderedSplitAddresses[prevPos];
                this.currentAddressIndex = prevOrdered._originalIndex;
                this.currentOrderedPosition = prevPos;
                this.$nextTick(() => {
                    this.loadProductsForAddress();
                    this.loadAssignedItems();
                });
                return true;
            }
            // First address: let caller change step
            return false;
        },
        proceedToNextStep() {
            // Emit event to proceed to next step (packaging)
            this.$emit('all-addresses-complete');
        }
    }
};
</script>

<style scoped>
.split-items-by-address {
    padding: 0px;
    margin-bottom: 80px;
}



.ship-to-header {
    font-size: 16px;
    margin-bottom: 8px;
}

.address-title {
    font-weight: 600;
    color: #1d6cb5;
}

.address-details .customer_name{
    font-size: 16px;
    line-height: 16px;
    font-weight: 700;
    color: #121212;
    font-family: 'mulish';
}

.products-summary_block {
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    gap: 12px;
    padding: 0px;
    margin-bottom: 0px;
    margin-top: 32px;
}
.products-summary_block p{
    margin-bottom: 0px;
    color: #121212;
    font-size: 14px;
    line-height: 14px;
    font-weight: 500;
    font-family: 'mulish';
}
.products-summary_block .total_product{
    padding-right: 16px;
    border-right: 1px solid #BEBEBE4D;
}
.products-table-section {
    overflow-x: auto;
    /* Show vertical scroll after ~8 rows */
    max-height: 600px;
    overflow-y: auto;
}

.table {
    width: 100%;
    border-collapse: collapse;
}

.split-items-by-address .table thead th {
    background-color: #F4F4F4;
    position: sticky;
    top: 0;
    z-index: 2;
    font-weight: 600;
    padding: 9px 16px;
    text-align: left;
    border-bottom: 2px solid #dee2e6;
    border-top: 1px solid #dee2e6;
    font-size: 12px;
    line-height: 12px;
    color: #121212;
    font-weight: 700;
    font-family: 'mulish';
}

.split-items-by-address .table tbody td {
    padding: 9px 16px;
    border-bottom: 1px solid #dee2e6;
    font-size: 12px;
    line-height: 12px;
    color: #121212;
    vertical-align: middle;
    font-weight: 500;
    font-family: 'mulish';
}

.split-items-by-address .table tbody tr:hover {
    background-color: #f8f9fa;
}

.split-items-by-address .table tbody td.text-center input[type="checkbox"] {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    width: 20px;
    height: 20px;
    border-radius: 2px;
    border: 1px solid #006FAC;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: relative;
}

/* Select-all header checkbox: spacing between "Select" and checkbox, slightly smaller */
.split-items-by-address .table thead th.select-col-header {
    white-space: nowrap;
}
.split-items-by-address .table thead th.select-col-header input.select-all-cb {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    width: 16px;
    height: 16px;
    border-radius: 2px;
    border: 1px solid #006FAC;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: relative;
    margin-left: 10px;
    vertical-align: middle;
}
.split-items-by-address .table thead th.select-col-header input.select-all-cb::after {
    content: "";
    width: 8px;
    height: 5px;
    border-left: 2px solid #fff;
    border-bottom: 2px solid #fff;
    transform: rotate(-45deg);
    opacity: 0;
    transition: opacity 0.15s ease-in-out;
    top: -1px;
    position: relative;
}
.split-items-by-address .table thead th.select-col-header input.select-all-cb:checked {
    background-color: #006FAC;
}
.split-items-by-address .table thead th.select-col-header input.select-all-cb:checked::after {
    opacity: 1;
}
/* Indeterminate = some selected: show as unchecked (no minus sign) */
.split-items-by-address .table thead th.select-col-header input.select-all-cb:indeterminate {
    background-color: transparent;
}
.split-items-by-address .table thead th.select-col-header input.select-all-cb:indeterminate::after {
    opacity: 0;
}

.split-items-by-address .table tbody td.text-center input[type="checkbox"]::after {
    content: "";
    width: 10px;
    height: 6px;
    border-left: 2px solid #fff;
    border-bottom: 2px solid #fff;
    transform: rotate(-45deg);
    opacity: 0;
    transition: opacity 0.15s ease-in-out;
        top: -2px;
    position: relative;
}
.split-items-by-address .table tbody td.text-center input[type="checkbox"]:checked{
    background-color: #006FAC;
}
.split-items-by-address .table tbody td.text-center input[type="checkbox"]:checked::after {
    opacity: 1;
}
.split-items-by-address .white_box.shipping_fl_left{
    padding: 24px 32px !important;
}

.disclaimer {
    font-size: 12px;
    line-height: 12px;
    color: #414141;
    font-style: italic;
    margin-top: 16px;
    position: absolute;
    bottom: -25px;
}
.disclaimer p {
    font-size: 12px;
    line-height: 12px;
    color: #414141;
    font-style: italic;
    margin: 0px;
}

.split-items-by-address .address-progress-bar {
    display: block !important;
    visibility: visible !important;
    margin-bottom: 0px;
    text-align: center;
    position: relative;
    right: -27px;
}

.split-items-by-address .progress-info {
    margin-bottom: 8px;
    text-align: left;
}

.split-items-by-address .progress-text {
    font-weight: 500;
    color: #121212;
    font-size: 14px;
    line-height: 14px;
    font-family: 'mulish';
}

.progress-bar-container {
    width: 140px;
    min-height: 28px;
    margin: 6px auto 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.progress-step {
    flex: 1;
    height: 6px;
    margin: 0 4px;
    background-color: #B6B6B666;
    border-radius: 0px;
    cursor: pointer;
    box-sizing: content-box;
    padding: 10px 0;
    background-clip: content-box;
}

.progress-step:first-child {
    margin-left: 0;
}

.progress-step:last-child {
    margin-right: 0;
}

.progress-step-active {
    background-color: #1D6CB5;
}

.progress-stats {
    font-size: 12px;
    color: #666;
    margin-top: 4px;
}

.progress-count {
    font-weight: 500;
}

.summary-screen {
    padding: 0px;
}

.alert-success {
    background-color: #00A05314;
    border-color: #00A05314;
    color: #00A053;
    padding: 13px 16px;
    border-radius: 4px;
    font-size: 14px;
    line-height: 14px;
    font-weight: 500;
     margin-bottom: 16px;
}

.alert-danger {
    background-color: #FF3B3014;
    border-color: #FF3B3014;
    color: #A6140C;
    font-size: 14px;
    line-height: 14px;
    padding: 13px 16px;
    border-radius: 4px;
    font-weight: 500;
    margin-bottom: 16px;
}

.addresses-summary-list {
    margin-top: 8px;
}

.address-summary-item {
    padding: 16px 0 12px 0px;
    border-bottom: 1px solid #e0e0e0;
    background-color: #fff;
}

.address-summary-item:last-child {
    border-bottom: none;
}

.address-summary-row {
    flex-wrap: wrap;
    gap: 12px;
}

.address-summary-left {
    flex: 1;
    min-width: 0;
}

.address-summary-label {
    font-weight: 700;
    color: #333;
    font-size: 14px;
    margin-right: 4px;
}

.address-summary-details {
    color: #333;
    font-size: 14px;
    font-weight: 400;
}

.address-summary-right {
    display: flex;
    align-items: center;
    gap: 16px;
    flex-shrink: 0;
}

.address-default-badge {
    display: inline-block;
    padding: 4px 10px;
    font-size: 12px;
    font-weight: 600;
    color: #fff;
    background-color: #1D6CB5;
    border-radius: 4px;
}

.address-set-default .set-default-text {
    margin-left: 8px;
    font-size: 14px;
    line-height: 14px;
    font-weight: 500;
    color: #121212;
    cursor: pointer;
    font-family: 'mulish';
}

.address-set-default.checkbox_custom {
    position: relative;
    display: inline-flex;
    align-items: center;
    cursor: pointer;
    padding-left: 0;
    padding-right: 28px;
}

.address-set-default.checkbox_custom input[type="radio"] {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    right: 0;
    left: auto;
    top: 0;
    width: 18px;
    height: 18px;
    margin: 0;
}

.address-set-default .radio-mark {
    position: absolute;
    top: 0;
    right: 0;
    left: auto;
    height: 18px;
    width: 18px;
    background-color: #fff;
    border: 2px solid #B6B6B6;
    border-radius: 50%;
}

.address-set-default input[type="radio"]:checked ~ .radio-mark {
    background-color: #fff;
    border-color: #1D6CB5;
}

.address-set-default input[type="radio"]:checked ~ .radio-mark:after {
    content: "";
    position: absolute;
    display: block;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #1D6CB5;
}

.address-products-count {
    font-size: 14px;
    color: #666;
    font-weight: 400;
}

.btn-add-product {
    padding: 0px 14px;
    font-size: 14px;
    font-weight: 400;
    color: #1D6CB5;
    background-color: #fff;
    border: 1px solid #1D6CB5;
    border-radius: 0px;
    cursor: pointer;
    transition: background-color 0.2s, color 0.2s;
    font-family: 'mulish';
    min-width: 113px;
}

.btn-add-product:hover {
    background-color: rgba(29, 108, 181, 0.08);
}

.btn-edit-address {
    padding: 6px;
    background: transparent;
    border: none;
    color: #333;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.btn-edit-address:hover {
    color: #1D6CB5;
}

.address-info {
    flex: 1;
}

.address-text {
    color: #666;
    font-size: 14px;
    line-height: 1.5;
}

.products-count {
    margin-top: 8px;
    color: #333;
    font-size: 14px;
}

.address-actions {
    display: flex;
    align-items: center;
    gap: 8px;
}

.address-actions .btn-sm {
    padding: 6px 12px;
    font-size: 14px;
}

.split-items-by-address h1{
    color: #121212;
    font-size: 24px;
    line-height: 24px;
    font-weight: 600;
    margin-bottom: 0px;
}
.split-items-by-address .address-details span{
    display: block;
    color: #414141;
    font-size: 16px;
    line-height: 16px;
    font-weight: 400;
    margin-bottom: 8px;
}
.split-items-by-address .badge-primary{
    color: #1D6CB5;
     font-weight: 600;
    font-size: 14px;
    line-height: 14px;
    background-color: #1D6CB51A;
    padding: 4px;
    border-radius: 4px;
}
.split-items-by-address .current-address-section{
    display: flex;
    align-items: baseline;
    gap: 16px;
}
.split-items-by-address .ship-to-text{
    font-size: 16px;
    line-height: 16px;
    font-weight: 700;
    color: #121212;
}

.split-items-by-address .address_main{
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    margin-bottom: 16px;
}
.badge-primary{
    color: #1D6CB5;
     font-weight: 600;
    font-size: 14px;
    line-height: 14px;
    background-color: #1D6CB51A;
    padding: 4px;
    border-radius: 4px;
    margin-left: 5px;
}
.add_address{
    letter-spacing: 0px;
    font-size: 14px;
    font-weight: 700;
    color: #1D6CB5;
}
input[type="radio"]:disabled {
    cursor: not-allowed;
    opacity: 0.5;
}
.address-set-default:has(input:disabled) {
    cursor: not-allowed;
    color: #b6b6b6;
}
</style>
